// ---------------------------------------------------------------------------
// HRIS module — Staff attendance (QR check-in) data access layer
// ---------------------------------------------------------------------------
// The public check-in page posts here when a staff member submits attendance
// after scanning the QR. It intentionally does NOT send an auth token (the page
// is public); the school is identified by the schoolCode / schoolId carried in
// the QR payload and validated server-side.
// ---------------------------------------------------------------------------
import axios from "axios";
import Axios from "../../../../axios";
import {hrisApiConstants} from "../constants/HrisConstants";

// A bare axios instance (no auth interceptor) so the public page can post
// without a logged-in session.
const PublicAxios = axios.create();

// POST /hris/attendance/check-in — AttendanceCheckInRequest
// payload: {
//   schoolCode, schoolId, session, date,
//   employeeCode, fullName, checkInAt (ISO), remarks
// }
export function staffCheckIn(payload) {
    return PublicAxios.post(hrisApiConstants.STAFF_ATTENDANCE_CHECK_IN, payload);
}

// POST /hris/attendance/check-out — AttendanceCheckOutRequest
// payload: {
//   schoolCode, schoolId, session, date,
//   employeeCode, fullName, checkOutAt (ISO), remarks
// }
export function staffCheckOut(payload) {
    return PublicAxios.post(hrisApiConstants.STAFF_ATTENDANCE_CHECK_OUT, payload);
}

// GET /hris/attendance?from=&to= — attendance records for the admin HRIS
// dashboard. Day-wise passes from === to; month-wise passes the month range.
// Uses the authenticated instance since this is the logged-in admin view.
export function fetchStaffAttendance({from, to, page = 0, size = 200} = {}) {
    return Axios.get(hrisApiConstants.STAFF_ATTENDANCE_BASE, {
        params: {
            from: from || undefined,
            to: to || undefined,
            page,
            size,
        },
    });
}
